module.exports = __webpack_public_path__ + "img/check-icon.bb306461.svg";